import { render, staticRenderFns } from "./NewMessage.vue?vue&type=template&id=245b6842&scoped=true&"
import script from "./NewMessage.vue?vue&type=script&lang=js&"
export * from "./NewMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b6842",
  null
  
)

export default component.exports